<!--  -->
<template>
  <div>
    <div style="display:flex;margin-bottom:10px">
      <el-input
        v-model="policyobj.keyword"
        style="width:250px"
        placeholder="请输入appid/ghid/公众号名称"
      />

      <el-select v-model="policyobj.status" placeholder="请选择状态" style="margin-left:10px">
        <el-option
          v-for="item in statusarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left:10px"
        @click="searchar"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh"
        @click="reset"
      >重置</el-button>
    </div>
    <div class="table_box">
      <el-table
        v-if="dataLoaded"
        ref="multipleTable"
        :data="arr"
        max-height="500"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="selectable"
        />
        <el-table-column
          prop="app_id"
          label="appId"
          width="200"
          align="center"
        />
        <el-table-column
          prop="account_name"
          label="名称"
          width="100"
          align="center"
        />
        <el-table-column
          prop="gh_id"
          label="ghid"
          width="140"
          align="center"
        />
        <el-table-column
          prop="status_text"
          label="绑定状态"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.status_text }}
            <el-button v-if="scope.row.status == 1" type="primary" size="mini" @click="updata(scope.row.app_id,scope.row.strategy_preview_no)">刷新</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="bind_time_at_text"
          label="绑定时间"
          align="center"
        />
        <el-table-column
          prop="bind_time_at_text"
          label="推送状态"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.push_status"
              :active-value="1"
              :inactive-value="2"
              active-color="#13ce66"
              inactive-text="停止"
              active-text="正常"
              :disabled="switchIsDisabled"
              @change="unBindStatusUpdate($event,scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="失败原因"
          align="center"
        />

      </el-table>
    </div>

    <pagination-right
      :current-page="policyobj.page"
      :total="total"
      :page-sizes="[100]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div style="margin-top:10px">
      <el-button type="primary" size="mini" @click="unbindclick">解绑</el-button>
    </div>
  </div>
</template>

<script>
import {
  getBindAccount,
  strategyPreviewBindRefresh, removeBindAppIds, stopStrategyPreview
} from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      dataLoaded: false,
      arr: [],
      id: null,
      multipleSelection: [],
      policyobj: {
        page: 1,
        pageSize: 100,
        keyword: null,
        status: 0
      },
      statusarr: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '待绑定'
      }, {
        value: 2,
        label: '绑定成功'
      }, {
        value: 3,
        label: '绑定失败'
      }],
      total: null,
      switchIsDisabled: false
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    send(e, arr) {
      console.log('e', e, arr)
      this.id = e
      this.getbinaccountwewe()
    },
    // 分页
    fetchPageSize(e) {
      this.policyobj.pageSize = e
      this.getbinaccountwewe()
    },
    fetchCurrentPage(e) {
      this.policyobj.page = e
      this.getbinaccountwewe()
    },
    selectable(row, index) {
      // eslint-disable-next-line eqeqeq
      return row.status != 3 // 通过某个值来进行判断，规定那一行的选择框被禁用
    },
    async getbinaccountwewe() {
      const data = await getBindAccount({
        ...this.policyobj,
        strategy_preview_no: this.id
      })
      this.total = data.data.total
      this.arr = data.data.list
      this.dataLoaded = true
    },
    searchar() {
      this.policyobj.page = 1
      this.getbinaccountwewe()
    },
    reset() {
      this.policyobj.page = 1
      this.policyobj.keyword = null
      this.policyobj.status = 0
      this.getbinaccountwewe()
    },
    // toggleSelection(rows) {
    //   if (rows) {
    //     rows.forEach(row => {
    //       this.$refs.multipleTable.toggleRowSelection(row)
    //     })
    //   } else {
    //     this.$refs.multipleTable.clearSelection()
    //   }
    // },
    handleSelectionChange(val) {
      this.multipleSelection = []
      val.forEach(item => {
        this.multipleSelection.push(item.app_id)
      })
    },
    // 解绑提交
    unbindclick() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择解绑账号',
          type: 'error'
        })
        return
      }
      this.$confirm('您确定要解绑吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        removeBindAppIds({
          strategy_preview_no: this.id,
          app_ids: this.multipleSelection
        }).then((res) => {
          this.$message({
            message: '解绑成功',
            type: 'success'
          })

          this.getbinaccountwewe()
          // this.$emit('unbink')
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    updata(appid, strategy_preview_no) {
      this.$confirm('您确定要刷新吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        strategyPreviewBindRefresh({
          strategy_preview_no: strategy_preview_no,
          app_id: appid
        }).then((res) => {
          this.$message({
            message: '刷新成功',
            type: 'success'
          })
          this.getbinaccountwewe()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    unBindStatusUpdate(val, item) {
      this.switchIsDisabled = true
      setTimeout(() => {
        this.switchIsDisabled = false
      }, 2000)
      stopStrategyPreview({
        strategy_preview_no: item.strategy_preview_no,
        app_id: item.app_id,
        push_status: item.push_status
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.getbinaccountwewe()
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
/* .table_box{
  max-height: 500px;
  overflow-x:hidden;
} */
</style>
